import React from "react";
import { menusForDisplay } from '../domain/menus';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Menu, { MenuProps } from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Link from '@material-ui/core/Link';
import HomeIcon from '@material-ui/icons/Home';
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import ContactMailIcon from '@material-ui/icons/ContactMail';
import PersonIcon from '@material-ui/icons/Person';


const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    menuUl: {
	   listStyleType: 'none',
	   margin: 0,
	   padding: 0,
	   overflow: 'hidden',
     // eslint-disable-next-line
     ['@media (min-width:780px)']: {
     }
    },
    menuLi: {
      // eslint-disable-next-line
      ['@media (min-width:780px)']: {
        float: 'left',
        padding: '0px 10px 0px 10px',
      }
    },
    menuLiA: {
	   display: 'block',
	   color: 'white',
	   textAlign: 'center',
      textDecoration: 'none',
      fontSize: "14px",
      // eslint-disable-next-line
      ['@media (min-width:780px)']: {
        fontSize: "20px",
      }
    },
  }),
);

const StyledMenu = withStyles({
  paper: {
    border: '1px solid #d3d4d5',
  },
})((props: MenuProps) => (
  <Menu
    elevation={0}
    getContentAnchorEl={null}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'center',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'center',
    }}
    {...props}
  />
));


const StyledMenuItem = withStyles(theme => ({
  root: {
    '&:focus': {
      backgroundColor: theme.palette.primary.main,
      '& .MuiListItemIcon-root, & .MuiListItemText-primary': {
        color: theme.palette.common.white,
      },
    },
  },
}))(MenuItem);


interface Props {
  menuLists: menusForDisplay[],
}

const PcMenuList: React.FC<Props> = props => {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };


  const list = props.menuLists.map((menu, index) => {
    return (
      <Link
        key={index}
        href={"#" + menu.anchor}
        style={{
          textDecoration: 'none',
          color: '#FFFFFF',
        }}
        onClick={handleClose}
      >
        <StyledMenuItem>
          <ListItemIcon>
            {menu.icon}
          </ListItemIcon>
          <ListItemText primary={menu.name} />
        </StyledMenuItem>
      </Link>
    );
  });

  return (
    <ul className={classes.menuUl}>
      <li className={classes.menuLi}>
        <Link
          href="https://service.awesome-linus.com"
          style={{ textDecoration: 'none' }}
        >
          <div>
            <Button
              aria-controls="simple-menu"
              aria-haspopup="true"
              style={{fontWeight: 'bold'}}
            >
              <HomeIcon color='primary' style={{marginRight:'5px'}} />
              Service Home
            </Button>
          </div>
        </Link>
      </li>
      <li className={classes.menuLi}>
        <Button
          aria-controls="simple-menu"
          aria-haspopup="true"
          onClick={handleClick}
          style={{fontWeight: 'bold'}}
        >
          <PersonIcon color='primary' style={{marginRight:'5px'}} />
          Portfolio
        </Button>
        <StyledMenu
          id="customized-menu"
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={handleClose}
        >
          {list}
        </StyledMenu>
      </li>
      <li className={classes.menuLi}>
        <Link
          href="https://service.awesome-linus.com/contact"
          style={{ textDecoration: 'none' }}
        >
          <div>
            <Button
              aria-controls="simple-menu"
              aria-haspopup="true"
              style={{fontWeight: 'bold'}}
            >
              <ContactMailIcon color='primary' style={{marginRight:'10px'}} />
              Contact
            </Button>
          </div>
        </Link>
      </li>
    </ul>

  );
};

export default PcMenuList;
